module.exports = __webpack_public_path__ + "img/58.7.Chla.f1300793.png";